



import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { IActionType } from '@/system/store'
import { CLEAR_AUTH_DATA } from '@/system/store/action-types'
import { LOGIN_NAME } from '@/features/auth/auth.router'
import { navBarLocalisationKeys } from '@/features/navBar/navBar.localisation'
import AuthService from '@/features/auth0/authService'

@Component
export default class LogOut extends Vue {
  private translations = navBarLocalisationKeys
  private auth = new AuthService()

  @Action(CLEAR_AUTH_DATA) clearAuth!: IActionType

  private handleLogOut () {
    this.auth.logout()
    this.$router.push({ path: '/' })
  }
}
